import React from 'react'
import { Panel, Row, Col } from 'rsuite'

export default function ProjectBasicInfoSubProject({ schema }) {
  return (
    <>
      <Panel shaded header={schema?.projectBasicInfoHeader} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -30 }}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Panel header={schema?.subProject?.header}>
              <Row style={{ marginTop: -20 }}>
                {schema?.subProject?.projectNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.projectNameTitle} :{' '}
                      <b>
                        {schema.subProject.projectName
                          ? schema.subProject.projectName
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.subProject?.projectCodeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.projectCodeTitle} :{' '}
                      <b>
                        {schema.subProject.projectCode
                          ? schema.subProject.projectCode
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.subProject?.ownerNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.ownerNameTitle} :{' '}
                      <b>
                        {schema.subProject.ownerName ? schema.subProject.ownerName : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.subProject?.responsinatorNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.responsinatorNameTitle} :{' '}
                      <b>
                        {schema.subProject.responsinatorName
                          ? schema.subProject.responsinatorName
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {/* {schema?.subProject?.projectTypeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.projectTypeTitle} :{' '}
                      <b>
                        {schema.subProject.activityType
                          ? schema.subProject.activityType
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )} */}

                {schema?.subProject?.projectStartEndDateTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.projectStartEndDateTitle} :{' '}
                      <b>
                        {schema.subProject.projectStartEndDate
                          ? schema.subProject.projectStartEndDate
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}

                {/* {schema?.subProject?.activityTypeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.subProject.activityTypeTitle}
                      <span
                        style={{ color: 'red' }}
                      >{` ${schema.subProject.activityTypeTitle2}`}</span>
                      {' : '}
                      <b>
                        {schema.subProject.activityType
                          ? schema.subProject.activityType
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )} */}
              </Row>
            </Panel>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Panel header={schema?.mainProject?.header}>
              <Row style={{ marginTop: -20 }}>
                {schema?.mainProject?.projectNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.projectNameTitle} :{' '}
                      <b>
                        {schema.mainProject.projectName
                          ? schema.mainProject.projectName
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.mainProject?.projectCodeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.projectCodeTitle} :{' '}
                      <b>
                        {schema.mainProject.projectCode
                          ? schema.mainProject.projectCode
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.mainProject?.ownerNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.ownerNameTitle} :{' '}
                      <b>
                        {schema.mainProject.ownerName ? schema.mainProject.ownerName : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.mainProject?.responsinatorNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.responsinatorNameTitle} :{' '}
                      <b>
                        {schema.mainProject.responsinatorName
                          ? schema.mainProject.responsinatorName
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {schema?.mainProject?.projectStartEndDateTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.projectStartEndDateTitle} :{' '}
                      <b>
                        {schema.mainProject.projectStartEndDate
                          ? schema.mainProject.projectStartEndDate
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )}
                {/* {schema?.mainProject?.projectTypeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.projectTypeTitle} :{' '}
                      <b>
                        {schema.mainProject.projectProposalType
                          ? schema.mainProject.projectProposalType
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )} */}
                {/* {schema?.mainProject?.projectTypeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.projectTypeTitle} :{' '}
                      <b>
                        {schema.mainProject.projectProposalType
                          ? schema.mainProject.projectProposalType
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )} */}
                {/* {schema?.mainProject?.ownerNameTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.ownerNameTitle} :{' '}
                      <b>
                        {schema.mainProject.ownerName ? schema.mainProject.ownerName : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )} */}
                {/* {schema?.mainProject?.activityTypeTitle && (
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 3 }}>
                    <span>
                      {schema.mainProject.activityTypeTitle}
                      <span
                        style={{ color: 'red' }}
                      >{` ${schema.mainProject.activityTypeTitle2}`}</span>
                      {' : '}
                      <b>
                        {schema.mainProject.projectType
                          ? schema.mainProject.projectType
                          : ' -ไม่ระบุ-'}
                      </b>
                    </span>
                  </Col>
                )} */}
              </Row>
            </Panel>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
